import IDMSessionAuthorization from './IDMSessionAuthorization';
import PersistentSession from './../browser/PersistentSession'
import AppIDv2 from '../Wrappers/AppIDv2';
import IDMGlobals from '../IDMGlobals';
//
export default class IDMSession {
  constructor(datasource) {
    //
    this.datasource = datasource;
    this.authorization = null; //only valid when token is valid
    this.data = new PersistentSession(this.datasource);
    //privates
    this._enqueuedValidations = [];
    this._enqueuedPKs = null;
  }
  /*public methods*/
  async loadSession(forceReload, optRedirectUrl, optExtraContext) {
    //Check if current saved session is from the same requesting user
    const userData = await this.data.getUserData();
    const userEmail = this.datasource.urlmanager.getUserEmail();
    
    //Check for cleaning if is trying to log with different user
    if ((userEmail && userData && userData.userObj && userData.userObj.email != userEmail)) {
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Cleaning session for different user.');
      await this.clearSession(true);
      return false;
    }

    //Load federation state to URL
    await this.datasource.urlmanager.loadFederationState();

    //Load previous session is allowed
    if (forceReload || !(await this._loadSavedSession())) {
      //Determine SSO code query param
      //Check if any renewal token valid from storage
      const token = await this.data.getRenewalToken();
      if (token && (await this.data.getUserObject())) { //checking for user is a sanity check
        //Force api call if forcing reload
        return await this._enqueueRenewSessionRequest(forceReload, optRedirectUrl || window.location, optExtraContext);
      } else if (this.datasource.urlmanager.getParam(IDMGlobals.URLQueryParam_FederationCode)) { //has external provider token
        const code = this.datasource.urlmanager.getParam(IDMGlobals.URLQueryParam_FederationCode).replace('#', '').replace('_', ''); //Google code something comes is a # and facebook with _
        this.datasource.urlmanager.deleteParam(IDMGlobals.URLQueryParam_FederationCode);
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Detected external provider login, asking for session renewal!');
        return await this.datasource.authenticator.loginFederationWithCode(code, optRedirectUrl || window.location.origin, optExtraContext /* not supported yet */);
      } else if (this.datasource.urlmanager.getParam(IDMGlobals.URLQueryParam_SSOCode)) { //has sso code
        const code = this.datasource.urlmanager.getParam(IDMGlobals.URLQueryParam_SSOCode);
        this.datasource.urlmanager.deleteParam(IDMGlobals.URLQueryParam_SSOCode);
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Detected SSO Code login, asking for session renewal!');
        return await this.datasource.authenticator.loginSSOWithCode(code);
      } else {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('No session');
        await this.clearSession(true); //make sure we cleanup
        return false;
      }
    } else {
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Previous session loaded');
      if (this.datasource.urlmanager.getParam(IDMGlobals.URLQueryParam_SSOCode)) this.datasource.urlmanager.deleteParam(IDMGlobals.URLQueryParam_SSOCode); //cleanup even if not used
      return true;
    }
  }
  //Getters
  async getToken(revalidate) {
    const token = (this.authorization ? this.authorization.token : null);
    if (token && this.authorization.isTokenValid()) return token;
    //no valid token, check if have renewal token, if so try to renew session
    if (revalidate) return await this._enqueueRenewSessionRequest(true);
    return null;
  }
  async getPublicToken() { return await this._enqueuePublicKeyRequest(); }
  isLogged() { return (this.authorization && this.authorization.token); }

  /* session management */
  async clearSession() {
    this.authorization = null;
    await this.data.clearData();
  }
  async setSessionWithData(_data) {
    //attempt to decode
    if (_data && _data.token) {
      this.authorization = new IDMSessionAuthorization(_data.token, this.datasource.opts.roles, this.datasource.opts.jwtAPIMode);
      //if decoded token is valid
      if (this.authorization.isTokenValid()) {
        //init session
        await this.data.saveSession(_data);
      } else this.authorization = null;
    }
  }

  /*private methods*/
  async _loadSavedSession() {
    //Check if have previous and valid authorization
    const token = await this.data.getToken()
    const authorization = new IDMSessionAuthorization(token, this.datasource.opts.roles, this.datasource.opts.jwtAPIMode);
    if (authorization && authorization.isTokenValid() && (await this.data.getUserObject())) { //checking for user is a sanity check
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Using saved session');
      this.authorization = authorization;
      //internall processing as the authentication as completed sucessfully
      await this.datasource.handleAuthenticationResponse(null, null, null, true);
      return true;
    } return false;
  }
  async _enqueueRenewSessionRequest(forceAPICall, redirectURL, optExtraContext) {
    const token = (this.authorization ? this.authorization.token : null);
    const userData = await this.data.getUserData();
    if (token && this.authorization.isTokenValid() && !forceAPICall) return token;
    //no valid token, check if have renewal token, if so try to renew session
    const renewalToken = await this.data.getRenewalToken();
    if (renewalToken && userData) {
      if (!this.datasource.authenticator.isAutheticating) {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Session is expired, renewing it.')
        //Request renewal
        await this.datasource.authenticator.validate(renewalToken, userData.userObj.email, forceAPICall, redirectURL, optExtraContext);
        //Get new token
        const newToken = (this.authorization ? this.authorization.token : null);
        //Release other enqueued renewals
        for (let cb of this._enqueuedValidations) cb(newToken);
        this._enqueuedValidations = [];
        //Respond this call!
        return newToken;
      } else {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Enqueued renewal request, another one is in progress, will reuse it\'s response.')
        //Enqueue responses
        return new Promise((resolve) => this._enqueuedValidations.push(resolve));
      }
    } return null;
  }
  async _enqueuePublicKeyRequest() {
    //attempt to fetch from storage
    let pk = await this.data.getPublicKey();
    if (!pk) {
      if (!this._enqueuedPKs) {
        this._enqueuedPKs = [];
        //PK Request 
        const pkResp = await this.datasource.api.publicKey.get();
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('PK resp', pkResp);
        if (pkResp && pkResp.statusCode == 200) {
          //Decode
          pk = pkResp.body.publicKey;
          //save it 
          await this.data.savePublicKey(pk);
        }
        //Format 
        pk = (pk ? AppIDv2.loadPublicKey(pk) : null); //return on common format
        //Release other enqueued renewals
        for (let cb of this._enqueuedPKs) cb(pk);
        this._enqueuedPKs = null;
        //return key to primaery requester
        return pk;
      } else {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Enqueued PK request, another one is in progress, will reuse it\'s response.')
        //Enqueue responses
        return new Promise((resolve) => this._enqueuedPKs.push(resolve));
      }
    } return (pk ? AppIDv2.loadPublicKey(pk) : null); //return on common format
  }

  /* partitions management */
  async getPartitionByName(name, loadIfRequired) {
    let partID = this.opts.partitions[name];
    if (!partID) return null;
    return await this.getPartitionByID(partID, loadIfRequired);
  }
  async getPartitionByID(id, loadIfRequired) {
    const data = await this.data.getUserData();
    if (!(data && data.parts)) return null;
    const parts = data.parts;
    if (parts[id]) return parts[id];
    //Try to find partition (if load flag is true)
    if (loadIfRequired) return await this._loadPartitionsIntoSession(id);
    //not found :/
    return null;
  }
  async invalidatePartitionByID(id) { await this.data.deletePartitionByID(id); }
  async _loadPartitionsIntoSession(partID) {
    const data = await this.data.getUserData();
    if (!(data && data.parts)) return null;
    const resp = await this.datasource.api.userPartition.read(partID, this.authorization.getUserID());
    if (resp && resp.statusCode == 200) {
      await this.data.appendPartitionDataByID(resp.body, partID);
      return resp.body;
    }
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.log('Partition read error: ', resp);
    return null;
  }
}
